var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('file-upload-preview',{attrs:{"example":_vm.example,"displayFiles":_vm.files,"asset":_vm.overlay,"instruction":_vm.instruction,"text":_vm.text,"minFiles":_vm.minFiles,"maxFiles":_vm.maxFiles,"textAlt":_vm.textAlt,"onDelete":_vm.handleDelete,"onUpload":_vm.handleUpload}})
}
var staticRenderFns = []

export { render, staticRenderFns }